module.exports = __webpack_public_path__ + "static/slider_1-a5fc47bb2ef9b1bd1eecdc86b45dcb63.jpg";